import { FormattedList, FormattedMessage } from 'react-intl';

import { messages } from './messages';
import { emptyArray } from 'ui-components/default-props/empty';
import { OrderNumberLink } from '../../../order-number-link';

/**
 * @param {object} props
 * @param {string} props.className
 * @param {string[]} props.fulfillmentPlanIds
 * @param {{salesOrderId: string, orderNumber: string}[]} props.salesOrders
 * @returns {JSX.Element}
 */
export const DisplaySummaryMessage = ({ className, fulfillmentPlanIds = emptyArray, salesOrders = emptyArray }) => {
  if (fulfillmentPlanIds.length === 1 && salesOrders.length > 1) {
    const orderNumbers = salesOrders.map((order) => {
      return (
        <OrderNumberLink
          key={order.salesOrderId}
          id={fulfillmentPlanIds[0]}
          orderNumber={order.orderNumber}
          salesOrderId={order.salesOrderId}
          selectGridWhenClicked
        />
      );
    });

    return (
      <div className={className}>
        <FormattedMessage
          {...messages.shipmentContainsItemsForOrders}
          values={{
            orderNumberList: <FormattedList type='conjunction' value={orderNumbers} />,
          }}
        />
      </div>
    );
  }

  if (fulfillmentPlanIds.length > 1) {
    const { orderNumber, salesOrderId } = salesOrders[0];

    return (
      <div className={className}>
        <FormattedMessage
          {...messages.shipmentPartiallyFulfillsOrder}
          values={{
            orderNumber: (
              <OrderNumberLink id={fulfillmentPlanIds[0]} orderNumber={orderNumber} salesOrderId={salesOrderId} selectGridWhenClicked />
            ),
          }}
        />
      </div>
    );
  }

  return null;
};
